mutation SetMicrosoftTeamsIsEnabled($input: SetMicrosoftTeamsIsEnabledInput!) {
    setMicrosoftTeamsIsEnabled(input: $input) {
        authUrl
        microsoftTeamsIntegration {
            isEnabled
        }
    }
}
